<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn 
                icon 
                dark 
                :disabled="submitLoading" 
                @click="cancel">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span>Edit NuPoint Spray Job</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md8 offset-md2 mt-4>
                    <v-container grid-list-md>
                        <v-layout v-if="loading">
                            <v-progress-linear 
                                :active="loading" 
                                :indeterminate="true">
                                </v-progress-linear>
                        </v-layout>
                        <v-layout v-else wrap>
                            <v-flex xs4>
                                <v-text-field
                                    box
                                    label="Job ID"
                                    disabled
                                    v-model="job.JobID">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                    box
                                    label="Job Type"
                                    disabled
                                    v-model="job.JobType">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-select v-model="job.JobStatus" :items="jobStatuses" :rules="[rules.requiredObject]" label="Job Status">
                                </v-select>
                            </v-flex>                            
                            <v-flex xs4>
                                <v-select v-model="job.PlantID" :items="plants" item-text="PlantName" item-value="PlantID" :rules="[rules.requiredObject]" @input="clearDivision" label="Plant">
                                </v-select>
                            </v-flex>
                            <v-flex xs4>
                                <v-select v-model="job.DivisionID" :items="divisions" item-text="DivisionName" item-value="DivisionID" :rules="[rules.requiredObject]" @input="clearLocation" label="Division">
                                </v-select>
                            </v-flex>
                            <v-flex xs4>
                                <v-select v-model="job.LocationID" :items="filteredlocations" item-text="LocationName" item-value="LocationID" :rules="[rules.requiredObject]" label="Location">
                                </v-select>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                    box
                                    label="Farm Name"
                                    disabled
                                    v-model="job.FarmName">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                    box
                                    label="Field Name"
                                    disabled
                                    v-model="job.FieldName">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                    box
                                    label="Spray Area"
                                    disabled
                                    v-model="job.SprayArea">
                                </v-text-field>
                            </v-flex>                   
                            <v-flex xs3>
                                <DateSelector label="Scheduled Start Date" :disabled="true" v-model="job.ScheduledStartDate"></DateSelector>
                            </v-flex>
                            <v-flex xs3>
                                <TimeSelector label="Scheduled Start Time" :disabled="true" v-model="job.ScheduledStartTime"></TimeSelector>
                            </v-flex>
                            <v-flex xs3>
                                <DateSelector label="Scheduled End Date" :disabled="true" v-model="job.ScheduledEndDate"></DateSelector>
                            </v-flex>
                            <v-flex xs3>
                                <TimeSelector label="Scheduled End Time" :disabled="true" v-model="job.ScheduledEndTime"></TimeSelector>
                            </v-flex>
                            <v-flex xs3>
                                <DateSelector label="Actual Start Date" v-model="job.ActualStartDate"></DateSelector>
                            </v-flex>
                            <v-flex xs3>
                                <TimeSelector label="Actual Start Time" v-model="job.ActualStartTime"></TimeSelector>
                            </v-flex>
                            <v-flex xs3>
                                <DateSelector label="Actual End Date" v-model="job.ActualEndDate"></DateSelector>
                            </v-flex>
                            <v-flex xs3>
                                <TimeSelector label="Actual End Time" v-model="job.ActualEndTime"></TimeSelector>
                            </v-flex>
                            <v-flex xs3>
                                <DateSelector label="ICA From Date" v-model="job.ICAFromDate"></DateSelector>
                            </v-flex>
                            <v-flex xs3>
                                <TimeSelector label="ICA From Time" v-model="job.ICAFromTime"></TimeSelector>
                            </v-flex>
                            <v-flex xs3>
                                <DateSelector label="ICA To Date" v-model="job.ICAToDate"></DateSelector>
                            </v-flex>
                            <v-flex xs3>
                                <TimeSelector label="ICA To Time" v-model="job.ICAToTime"></TimeSelector>
                            </v-flex>
                            <v-flex xs3>
                                <DateSelector label="WithHold End Date" v-model="job.WithHoldEndDate"></DateSelector>
                            </v-flex>
                            <v-flex xs3>
                                <TimeSelector label="WithHold End Time" v-model="job.WithHoldEndTime"></TimeSelector>
                            </v-flex>
                            <v-flex xs12>
                                <v-data-table
                                    :headers="headers"
                                    :items="job.Products">
                                    <template v-slot:items="{ item }">
                                        <td>{{ item.Label }}</td>
                                        <td>{{ item.ActiveIngredient }}</td>
                                        <td>{{ item.Comments }}</td>
                                        <td>{{ item.Rate }}</td>
                                        <td>{{ item.AmountUsed }}</td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>                    
                        <v-layout wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="success" 
                                    :disabled="!editValid" 
                                    :loading="submitLoading" 
                                    @click="submit">
                                    <span>Save</span>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="error" 
                                    :disabled="submitLoading" 
                                    @click="cancel">
                                    <span>Cancel</span>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12>
                                <v-alert 
                                    :value="submitError != null" 
                                    outline 
                                    type="error">
                                    <span>{{ submitError }}</span>
                                </v-alert>
                            </v-flex>
                        </v-layout>
                </v-container>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>    
</template>

<script>
import { mapState } from "vuex";
import validationRules from "@/helpers/validationrules";
import DateSelector from "@/components/generic/DateSelector.vue";
import TimeSelector from "@/components/generic/TimeSelector.vue";
import nuPointSprayApi from '@/api/nuPointSprayApi';

export default {
    components: {
        DateSelector,
        TimeSelector
    },
    props: {
        jobID: {
            required: true
        }
    },
    watch: {
        jobID: {
            handler: async function(val){
                if (val) {
                    this.loadJob(val);
                }
            },
            immediate: true
        }
    },
    data(){
        return {
            rules: validationRules.rules,
            job: {},
            jobStatuses:[],
            editValid: false,
            error: null,
            loading: false,
            submitLoading: false,
            submitError: null,
            headers: [
                {
                    text: "Label",
                    value: "Label",
                    sortable: true
                },
                {
                    text: "Active Ingredient",
                    value: "ActiveIngredient",
                    sortable: true
                },
                {
                    text: "Comments",
                    value: "Comments",
                    sortable: true
                },
                {
                    text: "Rate",
                    value: "Rate",
                    sortable: true
                },
                {
                    text: "Amount Used",
                    value: "AmountUsed",
                    sortable: true
                }
            ]
        }
    },
    computed: {
        ...mapState("NuPointSprayStore", [
            "locations",
        ]),
        plants() {
            // Distinct Plants
            const map = new Map();
            const result = [];
            for(const location of this.locations) {
                if(!map.has(location.Division.Plant.PlantID)) {
                    map.set(location.Division.Plant.PlantID);
                    result.push(location.Division.Plant);
                }
            }

            return result;
        },
        divisions() {
             // Distinct Divisions                
            const map = new Map();
            const result = [];
            for(const location of this.locations) {
                if(!map.has(location.Division.DivisionID) && location.Division.Plant.PlantID === this.job.PlantID) {
                    map.set(location.Division.DivisionID);
                    result.push(location.Division);
                }
            }

            return result;
        },
        filteredlocations() {
            return this.locations.filter(l => l.Division.DivisionID === this.job.DivisionID);
        }
    },
    methods: {
        clearDivision() {
            this.job.DivisionID = null;
            this.job.LocationID = null;
        },
        clearLocation() {
            this.job.LocationID = null;
        },
        cancel(){
            this.job = {};
            this.$emit("cancel");
        },
        async submit(){
            this.submitLoading = true;
            this.submitError = null;

            try {
                let response = await nuPointSprayApi.updateNuPointSprayJob(this.job.JobID, this.job);

                if (!response.Success) {
                    this.submitError = response.ErrorMessages.join(', ');
                    return;
                }

                this.$emit("saved");
            } catch (error) {
                this.submitError = error;
            } finally {
                this.submitLoading = false;
            }
        },
        async loadJob(jobID) {
            this.loading = true;
            this.job = await nuPointSprayApi.getNuPointSprayJob(jobID);
            this.loading = false;
        }
    },
    async created() {
        this.jobStatuses = await nuPointSprayApi.getNuPointSprayJobStatuses();
    }
}
</script>